// Booking location selector modal (vanilla JS)
// Supports multiple modals — each trigger finds its sibling modal within the card
// Close on bg click, X button, Escape, or location link click

document.addEventListener("DOMContentLoaded", function () {
  let currentModal = null;

  function openModal(modal) {
    currentModal = modal;
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    if (currentModal) {
      currentModal.classList.remove("is-open");
      document.body.style.overflow = "";
      currentModal = null;
    }
  }

  // Find the modal for a given trigger — works in both card and carousel layouts
  function findModal(trigger) {
    // Card layout: .card wraps both trigger and modal
    var card = trigger.closest(".card");
    if (card) {
      var m = card.querySelector("[data-booking-modal]");
      if (m) return m;
    }
    // Carousel layout: .team-carousel-content wraps both
    var carousel = trigger.closest(".team-carousel-content");
    if (carousel) {
      var m = carousel.querySelector("[data-booking-modal]");
      if (m) return m;
    }
    // Fallback: walk up to find the nearest ancestor with a modal
    var el = trigger.parentElement;
    while (el && el !== document.body) {
      var m = el.querySelector("[data-booking-modal]");
      if (m) return m;
      el = el.parentElement;
    }
    return null;
  }

  // Open: trigger button finds its sibling modal
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-booking-modal-trigger]");
    if (!trigger) return;
    e.preventDefault();
    var modal = findModal(trigger);
    if (modal) openModal(modal);
  });

  // Close: background overlay click
  document.addEventListener("click", function (e) {
    if (!currentModal) return;
    const bg = currentModal.querySelector(".modal__bg");
    if (bg && e.target === bg) closeModal();
  });

  // Close: X button click (only the current modal's close button)
  document.addEventListener("click", function (e) {
    if (!currentModal) return;
    const close = e.target.closest(".modal__close");
    if (close && currentModal.contains(close)) closeModal();
  });

  // Close: location link click within the current modal
  document.addEventListener("click", function (e) {
    if (!currentModal) return;
    const link = e.target.closest(".modal__content a.btn");
    if (link && currentModal.contains(link)) closeModal();
  });

  // Close: Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && currentModal) closeModal();
  });
});
